var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5725 14.8503V18.1616V20.2878L19.9912 14.8503H17.8725H14.5725Z",
    fill: "#EB4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.18 3.50659H5.46001C4.86327 3.50659 4.29098 3.74364 3.86903 4.16559C3.44706 4.58754 3.21001 5.15987 3.21001 5.7566V18.4766C3.21001 19.0733 3.44706 19.6456 3.86903 20.0676C4.29098 20.4895 4.86327 20.7266 5.46001 20.7266H13.0725V14.1004C13.0725 13.9014 13.1515 13.7107 13.2922 13.57C13.4328 13.4294 13.6236 13.3504 13.8225 13.3504H20.43V5.7566C20.43 5.15987 20.1929 4.58754 19.771 4.16559C19.349 3.74364 18.7767 3.50659 18.18 3.50659Z",
    fill: "#FADA80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.272c8b9641094cfce5ddf35ed155cade.svg";
export { ForwardRef as ReactComponent };